module.exports = __webpack_public_path__ + "img/3.1a010f89.webp";